import { render } from "./foot.vue?vue&type=template&id=af5df8c8&scoped=true"
const script = {}

import "./foot.vue?vue&type=style&index=0&id=af5df8c8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_data_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5df8c8"]])

export default __exports__